<div class="animate__animated animate__fadeInRight">
  <br />

  <div class="col">
      <mat-card class="mat_card_general p-5">
          <h1 class>Módulo de Días Libres</h1>
      </mat-card>
  </div>

  <br />
 <mat-card class="mat-elevation-z0 mat_card_general_content">


      <app-lista-dias-libres  ></app-lista-dias-libres>

  </mat-card>
  <hr />
</div>
